import * as z from "zod";

export const authorizeFaireIntegration = {
  name: "authorizeFaireIntegration" as const,
  input: z.object({ authorizationCode: z.string(), teamId: z.string() }),
  output: z.object({
    success: z.boolean(),
    failureMessage: z.string().nullish(),
  }),
};
